<template>
    <div class="card">
        <div class="card-header">
            个人基本信息管理
        </div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">姓名</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.personName}}</td>
                <th class="text-center align-middle" style="width: 15%">性别</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.genderName}}</td>
            </tr>
            <tr v-if="showDetailInfo">
                <th class="text-center align-middle" style="width: 15%">身份证号码</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.cardId}}</td>
                <th class="text-center align-middle" style="width: 15%">出生日期</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.birthdateString}}</td>
            </tr>
            <tr v-if="showDetailInfo">
                <th class="text-center align-middle" style="width: 15%">民族</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.nation}}</td>
                <th class="text-center align-middle" style="width: 15%">政治面貌</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.politicalOutlook}}</td>
            </tr>
            <tr v-if="showDetailInfo">
                <th class="text-center align-middle" style="width: 15%">学历</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.education}}</td>
                <th class="text-center align-middle" style="width: 15%">学位</th>
                <td class="text-left align-middle" style="width: 35%">{{personBasicInfo.degree}}</td>
            </tr>
            <tr v-if="showDetailInfo">
                <th class="text-center align-middle" style="width: 15%">专业</th>
                <td class="text-left align-middle" colspan="3">{{personBasicInfo.major}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";

export default {
    name: "OrganPersonBasicInfoView",
    props: {
        personId: {type: String, required: true},
        showDetailInfo: {type: Boolean, required: false, default: true},
    },
    data: function () {
        return {
            personBasicInfo: {}
        };
    },
    mounted() {
        this.getPersonBasicInfo();
    },
    methods: {
        getPersonBasicInfo() {
            userApi.person.basic.getOrganBasicInfo(this.personId).then(res => {
                this.personBasicInfo = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>